import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Card,
  Header2,
  Underlined,
  Paragraph,
  Image,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const UtilityAdvantages = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query UtilityAdvantagesHeroImageQuery {
          file(relativePath: { eq: "utility_advantages.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 70% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 571px;
        }
      `}
    >
      <Header2>
        {"Utility Advantages"}
        <Underlined />
      </Header2>
      <Paragraph>
        {
          "Savant Power provides detailed real-time and hyper-localized information on distributed energy resources with the utility service area. Utility requests for load manipulation are received and reacted to in accordance with the individual user's preferences."
        }
      </Paragraph>
    </Card>
  </Section>
);
